import * as React from 'react';

/**
 * Hook to detect resize on page.
 * This is useful when a ref needs to be updated on resize.
 * @returns {boolean} state
 */
export default function useCheckResize() {
  var [state, setState] = React.useState(false);
  var supportsEvents = typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined';
  var toggleCheckResize = React.useCallback(() => setState(prevState => !prevState), []);
  React.useEffect(() => {
    var handleToggle = () => {
      toggleCheckResize();
    };
    if (supportsEvents) {
      var _window;
      (_window = window) === null || _window === void 0 || _window.addEventListener('resize', handleToggle);
    }
    return () => {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || _window2.removeEventListener('resize', handleToggle);
    };
  }, [supportsEvents, toggleCheckResize]);
  return state;
}